<script setup>
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { LogIn, ShieldCheck } from "@lucide/vue";
import { useSessionStore } from "../stores/session";

const session = useSessionStore();
const router = useRouter();
const route = useRoute();
const username = ref("");
const password = ref("");
const error = ref("");
const loading = ref(false);
async function submit() {
  loading.value = true;
  error.value = "";
  try {
    await session.login(username.value, password.value);
    router.replace(String(route.query.next || "/"));
  } catch (err) {
    error.value = err.message;
  } finally {
    loading.value = false;
  }
}
</script>
<template>
  <main
    class="grid min-h-screen lg:grid-cols-[minmax(0,1.05fr)_minmax(430px,.95fr)]"
  >
    <section
      class="relative hidden overflow-hidden bg-ink-900 p-12 text-white lg:flex lg:flex-col"
    >
      <div
        class="absolute inset-0 opacity-[.08]"
        style="
          background-image: radial-gradient(
            circle at 1px 1px,
            #fff 1px,
            transparent 0
          );
          background-size: 28px 28px;
        "
      ></div>
      <div class="relative flex items-center gap-3">
        <div class="grid size-12 place-items-center rounded-lg bg-white">
          <img
            src="/assets/valilik.png"
            class="size-10 object-contain"
            alt=""
          />
        </div>
        <div>
          <strong class="block">Kayseri Valiliği</strong
          ><span class="text-sm text-slate-400">Erva Spor Okulları</span>
        </div>
      </div>
      <div class="relative my-auto max-w-xl">
        <span
          class="mb-5 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-1.5 text-xs font-semibold text-slate-300"
          ><ShieldCheck class="size-4 text-brand-500" /> Güvenli geçiş
          yönetimi</span
        >
        <h1 class="text-5xl font-extrabold leading-[1.08]">
          Her geçişi net,<br />her anı kontrol altında.
        </h1>
        <p class="mt-6 max-w-lg text-base leading-7 text-slate-400">
          Kayseri Valiliği Erva Spor Okulları öğrenci geçiş, katılım ve turnike yönetim sistemi.
        </p>
      </div>
      <p class="relative text-xs text-slate-500">
        LopiyTech altyapısı ile geliştirilmiştir.
      </p>
    </section>
    <section class="grid place-items-center bg-slate-50 p-6 sm:p-12">
      <div class="w-full max-w-md">
        <div class="mb-9 lg:hidden">
          <img
            src="/assets/valilik.png"
            class="size-16 object-contain"
            alt=""
          />
        </div>
        <p class="page-kicker">Erva Spor Okulları Yönetim Paneli</p>
        <h2 class="text-3xl font-extrabold text-ink-950">
          Tekrar hoş geldiniz
        </h2>
        <p class="mt-2 text-sm text-slate-500">
          Devam etmek için hesabınızla giriş yapın.
        </p>
        <form class="mt-8 space-y-5" @submit.prevent="submit">
          <label class="field"
            ><span class="field-label">Kullanıcı adı</span
            ><input
              v-model="username"
              class="input h-12"
              autocomplete="username"
              required /></label
          ><label class="field"
            ><span class="field-label">Şifre</span
            ><input
              v-model="password"
              class="input h-12"
              type="password"
              autocomplete="current-password"
              required
          /></label>
          <p
            v-if="error"
            class="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm font-medium text-red-700"
          >
            {{ error }}
          </p>
          <button class="btn-primary h-12 w-full" :disabled="loading">
            <span>{{ loading ? "Kontrol ediliyor..." : "Giriş Yap" }}</span
            ><LogIn class="size-4" />
          </button>
        </form>
      </div>
    </section>
  </main>
</template>
